import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { criticalAlertsPercentage, criticalAlertsPercentageDelta = 0 } =
      data || {};

    return createKpiTileItem(
      'Critical Alerts',
      formatPercentageValue(criticalAlertsPercentage),
      Number(criticalAlertsPercentageDelta) !== 0
        ? {
            isPositiveValue: criticalAlertsPercentageDelta >= 0,
            text: formatPercentageValue(
              Math.abs(criticalAlertsPercentageDelta)
            ),
            sideLabel: '',
          }
        : null
    );
  },
};
